"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MarkdownMessage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const store_1 = require("../../store");
const user_1 = require("../../store/selectors/user");
const subscription_1 = require("../../store/selectors/subscription");
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const useChatMessages_1 = require("../../hooks/useChatMessages");
const spacing_1 = require("../../common/spacing");
const colors_1 = require("../../common/colors");
const borders_1 = require("../../common/borders");
const constants_1 = require("../../common/constants");
const AppText_1 = require("../AppText");
const appState_1 = require("../../slices/appState");
function MarkdownMessage({ diveDeeper, children }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { request } = (0, useRequest_1.default)();
    const { sendMessageAsStream } = (0, useChatMessages_1.useChatMessages)();
    const isCharacterTyping = (0, react_redux_1.useSelector)(user_1.selectIsCharacterTyping);
    const isChatImageLoading = (0, react_redux_1.useSelector)(user_1.selectIsChatImageLoading);
    const messagesQuota = (0, react_redux_1.useSelector)(subscription_1.selectConversationQuota);
    const handleDiveDeeperQuestionPress = (0, react_1.useCallback)((question) => {
        if (messagesQuota.quota - messagesQuota.consumed > 0) {
            request(sendMessageAsStream, { message: question });
        }
        else {
            dispatch((0, appState_1.setAppError)(constants_1.OUT_OF_QUOTA_MESSAGES));
        }
        ;
    }, [messagesQuota, sendMessageAsStream, request]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_markdown_1.default, { className: 'message-markdown', remarkPlugins: [remark_gfm_1.default], components: {
                pre({ className, children, ...restProps }) {
                    if (children !== 'string' && !Array.isArray(children)) {
                        const isMultiline = ((children
                            .props.children?.toString().match(/\n/g)?.length ?? 0) > 1);
                        console.log(children
                            .props.children?.toString().match(/\n/g));
                        return ((0, jsx_runtime_1.jsx)("pre", { className: `${className ?? ''} code_${isMultiline ? 'block' : 'inline'}`, ...restProps, children: children }));
                    }
                },
                table(props) {
                    return ((0, jsx_runtime_1.jsx)("div", { className: 'table-wrapper', children: (0, jsx_runtime_1.jsx)("table", { ...props }) }));
                },
                ...(diveDeeper && {
                    ol({ children }) {
                        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.diveDeeperButtonsContainer, children: children }));
                    },
                    li({ children }) {
                        const [isHovering, setIsHovering] = (0, react_1.useState)(false);
                        return ((0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPointerEnter: () => setIsHovering(true), onPointerLeave: () => setIsHovering(false), disabled: isCharacterTyping || isChatImageLoading, onPress: () => handleDiveDeeperQuestionPress(children?.toString() ?? ''), style: [styles.diveDeeperButton, isHovering && styles.diveDeeperButtonHover], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.diveDeeperButtonText, children: children }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonArrowContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faArrowRight, size: 10, color: colors_1.Colors.PRIMARY_300 }) })] }));
                    }
                })
            }, children: children }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    diveDeeperButtonsContainer: {
        gap: spacing_1.Spacing.SPACING_MD,
        paddingRight: 16,
        marginVertical: 20,
    },
    diveDeeperButton: {
        backgroundColor: `${colors_1.Colors.PRIMARY_300}30`,
        gap: 10,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: spacing_1.Spacing.SPACING_MD,
        borderRadius: borders_1.Borders.RADIUS_LG,
    },
    diveDeeperButtonHover: {
        backgroundColor: `${colors_1.Colors.PRIMARY_300}4C`,
    },
    diveDeeperButtonText: {
        color: 'white',
        fontSize: 12,
        fontWeight: '500',
        lineHeight: 20,
    },
    buttonArrowContainer: {
        backgroundColor: `${colors_1.Colors.PRIMARY_BLUE}26`,
        width: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 12,
    }
});
